import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { useWorkerPendingShiftInvites } from "@src/appV2/redesign/WorkerShifts/ShiftInvites/api/useWorkerPendingShiftInvites";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useCallback } from "react";

import { InviteRequiredPageContent } from "./PageContent";

export function InviteRequiredPage() {
  const { userId } = useDefinedWorker();
  const { data: { clipboardScore = 0 } = {}, refetch: refetchClipboardScoreProfile } =
    useGetClipboardScoreProfile(userId);
  const { data: { data: invites } = {}, refetch: refetchShiftInvites } =
    useWorkerPendingShiftInvites();

  const refreshAllData = useCallback(async () => {
    await Promise.all([refetchClipboardScoreProfile(), refetchShiftInvites()]);
  }, [refetchClipboardScoreProfile, refetchShiftInvites]);

  const invitesCount = invites?.length ?? 0;

  return (
    <InviteRequiredPageContent
      clipboardScore={clipboardScore}
      invitesCount={invitesCount}
      onRefresh={refreshAllData}
    />
  );
}
